import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export type TReportIssueData = {
  reason: string;
  reference: string;
};

interface TReportResourcesIssue {
  subTopicId: string;
  userId: string;
  pageNo?: string;
  reason: string;
  questionId?: string;
}

const apiDataProvider = new APIDataProvider();

export const reportIssue = createAsyncThunk(
  'report-issue',
  async (data: TReportIssueData) => {
    return apiDataProvider.post(ApiPaths.reportIssue, data);
  }
);

export const reportResources = createAsyncThunk(
  'report-issue/resource',
  async (data: TReportResourcesIssue) => {
    const response = await apiDataProvider.post<TApiResponse<any>>(
      `${ApiPaths.reportIssue}/resource`,
      data
    );

    return response.data;
  }
);
